import { useField, useFormikContext } from "formik";
import MetaTextarea from "./MetaTextArea";
import { Descendant } from "slate";

interface MetaTextareaFormikProps {
  name: string;
  label?: string;
}

export default function MetaTextareaFormik({ name, label }: MetaTextareaFormikProps) {
  const { setFieldValue } = useFormikContext();
  const [field] = useField(name);

  return (
    <div>
      {label && <label className="block mb-2 text-sm font-medium text-gray-700">{label}</label>}
      <MetaTextarea
        initialValue={
          field.value
            ? [{ type: "paragraph", children: [{ text: field.value }] } as Descendant]
            : undefined
        }
        onChangePlain={(text) => setFieldValue(name, text)}
      />
    </div>
  );
}
